module.exports = __webpack_public_path__ + "static/media/thierry-mugler-aura-mugler-big.e1f3ca06.png";